<template>
  <div class="">
    <div class="request-link-form">
      <div class="request-link-title m-2 text-size-18 text-weight-semi-bold">
        {{ $t('login.resetPassword') }}
      </div>
     

      <div  class="p-2">
        <InputTextValidated
          type="password"
          inputClass="login-field"
          :label="$t('login.lblPassword')"
          v-model="form.password"
        />
        <span class="text-danger text-size-12" v-if="errors.password">
          {{ errors.password[0] }}
        </span>
      </div>

      <div v-if="0" class="p-2">
        <InputTextValidated
          type="password"
          inputClass="login-field"
          :label="$t('login.lblConfirmPassword')"
          v-model="form.password_confirmation"
        />
        <span class="text-danger text-size-14" v-if="errors.password_confirmation">
          {{ errors.password_confirmation[0] }}
        </span>
      </div>

      <div class="request-link__footer m-2 text-center justify-content-end">
        <BtnLink @click.native="onBackToLogin" :label="$t('general.cancel')" />
        <Btn
          @click.native="onResetPassword"
          :label="$t('login.btnChangePassword')"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import { HTTP } from '@/shared/http';

export default {
  name: 'RequestPassword',

  data() {
    return {
      loading: false,
      form: {
        //email: null,
        password: null,
        //password_confirmation: null,
        token: null,
      },
    };
  },

  mixins: [formValidationMixin],
  
  components: {
    
  },

  computed: {
    confirmMessage() {
      let msg = this.$t('login.resetPasswordRequested');
      return msg.replace('%s', this.form.email);
    },
  },

  methods: {
    onBackToLogin() {
      this.$router.push('/signin');
    },

    onResetPassword() {
      // try to reset the password 
      this.clearErrors();      
      // if (!this.isValidEmail()) return;
      if (!this.isValidPassword()) return;


      console.log("Reset password was called");  
      this.loading =  true;
      const url = '/api/password/reset';
        HTTP.post(url, {
        token: this.token,
        email: this.email,
        password: this.form.password,
        password_confirmation: this.form.password,
      })
        .then((response) => {
          this.loading = false;
          console.log('Processing the loaded contacts:', response);
          this.$router.push("/passwordchanged")
        })
        .catch((error) => {
          this.loading = false;
          // this.$router.push("/passwordchanged")
          if (error.response.status != 422) {
            this.showError('password', this.$t('general.servererror'));
          }
          this.showError('password', this.$t(error.response.data.error.message));
        });
    },
  },

  mounted() {
    this.token = this.$route.params.token;
    this.email = this.$route.params.email;
  },
};
</script>

<style lang="scss" scoped>
.request-link__footer {
  display: flex;
  flex-direction: row;
}
</style>
